import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "chevron"]

  toggle(event) {
    event.preventDefault()

    const menu = this.menuTarget
    const chevron = this.chevronTarget

    menu.classList.toggle("hidden")
    chevron.classList.toggle("rotate-180")
  }
}
